import React from 'react'

const Manual_generacion_de_credenciales = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
    <div className="mt-16">
     <h2 className="font-bold xl:text-[40px] lg:text-4xl md:text-4xl text-4xl text-[#002D33] mb-5">
     Yappy - Generación de Credenciales
     </h2>
     <p className="text-lg text-gray-700 mb-6">
     La guía proporciona un proceso simple para obtener las credenciales necesarias
          para integrarse con la plataforma de pagos Yappy. Simplifica los pasos para que
          los usuarios puedan obtener rápidamente su clave API y clave secreta únicas.
          Siguiendo esta guía, los usuarios pueden configurar fácilmente la integración de
          pagos con InvuPOS, mejorando sus capacidades de transacción.
     </p>
     <iframe
          src="https://scribehow.com/embed/Yappy__Generacion_de_Credenciales__JUySvl-sQ_q95vYmlsFpfg?as=scrollable"
          className="scribe-iframe-yappy-3"
          width="100%"
          height="5300"
          allowFullScreen
          style={{
            aspectRatio: '1 / 1',
            border: 0,
            minHeight: '480px'
          }}
      ></iframe>
   </div>
   </div>
  )
}

export default Manual_generacion_de_credenciales